
export const advertStore = {
    state: {
        copyAsModalOpened: false,
        copyAsModel: {},
        soldModalOpened: false,
        soldModel: {},
        rentedModalOpened: false,
        rentedModel: {},
        favoriteListingState: {},
    },
    mutations: {
        openCopyAsModal(state, model) {
            state.copyAsModalOpened = true;
            state.copyAsModel = model;
        },
        closeCopyAsModal(state) {
            state.copyAsModalOpened = false;
        },
        openDeleteModal() { },
        openConfirmAdvertDeleteModal() { },
        openSoldModal(state, model) {
            state.soldModalOpened = true;
            state.soldModel = model;
        },
        closeSoldModal(state) {
            state.soldModalOpened = false;
        },
        openRentedModal(state, model) {
            state.rentedModalOpened = true;
            state.rentedModel = model;
        },
        closeRentedModal(state) {
            state.rentedModalOpened = false;
        },
        openHideModal() { },
        setFavoriteListingState(state, model) {
            state.favoriteListingState[model.listingId] = model.state;
        },
    },
};
